export default "__VITE_ASSET__BeXl91sG__"